import { BigNumber } from '@ethersproject/bignumber'
import { formatUnits } from '@ethersproject/units'
import { Pair } from '../../model'

export function getRemoveLiquidityFeeDisplay(pair: Pair) {
  return `${formatUnits(pair.getBurnFee().div(BigNumber.from(10).pow(14)), 2)}%`
}

export function getAddLiquidityFeeDisplay(pair: Pair) {
  return `${formatUnits(pair.getMintFee().div(BigNumber.from(10).pow(14)), 2)}%`
}
